const socialRedirectUrls = {
  discord: "https://discord.gg/mKX3rPSpUq",
  facebook: "https://www.facebook.com/share/1BJU5fSRZY/?mibextid=wwXIfr",
  twitter: "https://x.com/PlanetJ_bet",
  tiktok: "https://www.tiktok.com/@planetj.bet?_t=ZS-8vmAU4D1mES&_r=1",
  // Add more as needed
};

const urls = {
  webApp: "<URL>",
  // Add more as needed
};

export { socialRedirectUrls, urls };
